export var TOOLTIP_DURATION = 2000;
export var PIGGY_LOW_BET_TOOLTIP_DURATION = 3000;
export var PIGGY_LOW_BET_TOOLTIP_STORAGE_KEY = 'PIGGY_LOW_BET_TOOLTIP_SHOWN';